/**
 * PURPOSE:
 * Renderizar el listado público de categorías de Karate.
 *
 * RESPONSIBILITIES:
 * - Mostrar una grilla responsive de cards compactos.
 * - Manejar estado vacío sin romper la pantalla pública.
 *
 * COLLABORATORS:
 * - CategoriasKarate.jsx
 * - KarateCategoryCard.jsx
 *
 * ROUTE:
 * src/components/Software/Karate/Categorias/components/KarateCategoryList.jsx
 */

import React from "react";
import KarateCategoryCard from "./KarateCategoryCard.jsx";

export default function KarateCategoryList({ categories = [], onSelect }) {
  if (!categories.length) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-6 text-center shadow-sm">
        <p className="text-base font-black text-slate-800">No hay categorías disponibles</p>
        <p className="mt-2 text-sm font-semibold text-slate-500">
          Prueba recargar o revisa que las llaves ya estén generadas en KarateSoft.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {categories.map((category) => (
        <KarateCategoryCard
          key={category?.id ?? category?.code}
          category={category}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
